import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SelfDisclosureQuestion } from '@ui/shared/model';

import { TranslatePipe } from '@ngx-translate/core';

import { defaultDocumentsConfig } from '../../../config/documents.config';
import { AttachmentsComponent } from '../../../components/legacy/form/controls/attachment/attachments.component';
import { FormFieldComponent } from '../../../components/legacy/form/form-field/form-field.component';

@Component({
  selector: 'app-self-disclosure-document',
  templateUrl: './self-disclosure-document.component.html',
  styleUrls: ['./self-disclosure-document.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    AttachmentsComponent,
    FormFieldComponent
  ]
})
export class SelfDisclosureDocumentComponent {
  readonly selfDisclosureQuestion = input<SelfDisclosureQuestion>(undefined);
  readonly form = input<FormGroup>(undefined);
  readonly multiple = input(false);
  readonly storeAsArray = input(false);

  public acceptedDocumentsTypes = defaultDocumentsConfig.allAcceptedTypes;
  public documentsMaxSize = 1024 * 1024 * 20;

  public get getFormControl() {
    return this.form().get('answer') as FormGroup;
  }

  public get getUploadFormControl() {
    return this.form().get('uploads') as FormGroup;
  }

  public get isDocumentValid() {
    return (
      !this.getUploadFormControl.valid && this.getUploadFormControl.touched
    );
  }
}
